import { Typography } from '@mui/material'
import { css, styled } from '@mui/system'
import { WHLogo } from 'components'
import { AuthContext, DataContext } from 'contexts'
import { useContext } from 'react'

interface Props {
  isFullpage?: boolean
  title?: string
}

const Wrapper = styled('div')<{ isFullpage?: boolean }>(
  ({ isFullpage = true }) => css`
    position: ${isFullpage ? 'fixed' : 'absolute'};
    background: #fff;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
  `
)

const LogoWrapper = styled(`div`)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
  width: 150px;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ComingSoon = (props: Props) => {
  const { isFullpage = true } = props

  const { features } = useContext(DataContext)
  const { authUser } = useContext(AuthContext)

  if (!features?.isHomepageBlocked || !!authUser) {
    return null
  }

  return (
    <Wrapper isFullpage={isFullpage}>
      <LogoWrapper>
        <WHLogo />
        <Typography>Coming Soon</Typography>
      </LogoWrapper>
    </Wrapper>
  )
}
